var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 49 43",
    style: {
      enableBackground: "new 0 0 49 43"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#020202;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.55,7.93c-8.66,0-15.97,4.66-15.97,10.16c0,0.4,0.33,0.73,0.73,0.73s0.73-0.33,0.73-0.73 c0-4.64,6.79-8.71,14.52-8.71c0.4,0,0.73-0.33,0.73-0.73S23.95,7.93,23.55,7.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25,0.67c-12.83,0-23.23,7.8-23.23,17.42c0,5.99,4.04,11.28,10.17,14.41c0,0.04-0.01,0.07-0.01,0.11 c0,2.6-1.94,5.41-2.8,6.88h0c-0.07,0.16-0.11,0.33-0.11,0.52c0,0.73,0.59,1.32,1.32,1.32c0.14,0,0.38-0.04,0.37-0.02 c4.54-0.74,8.81-4.91,9.8-6.12c1.45,0.21,2.95,0.33,4.48,0.33c12.83,0,23.23-7.8,23.23-17.42S37.83,0.67,25,0.67 M25,32.62 c-1.33,0-2.7-0.1-4.06-0.3c-0.14-0.02-0.28-0.03-0.42-0.03c-0.86,0-1.69,0.39-2.24,1.06c-0.62,0.76-2.39,2.44-4.48,3.69 c0.57-1.3,1.01-2.76,1.04-4.26c0.01-0.09,0.01-0.19,0.01-0.27c0-1.09-0.61-2.09-1.58-2.58c-5.38-2.75-8.59-7.17-8.59-11.83 c0-8.01,9.12-14.52,20.33-14.52c11.21,0,20.33,6.51,20.33,14.52S36.21,32.62,25,32.62"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessage);
export default __webpack_public_path__ + "static/media/chatMessage.986e5d375dad85f3fd3cb6f99d87a422.svg";
export { ForwardRef as ReactComponent };